export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  'pipeline_manage',
  'pipeline_view',
  // NOOVI: gestão de Follow Up (templates + automações) — Gap FU-A (fase-11)
  'follow_up_manage',
  // NOOVI: gestão de Atendimentos (ações privilegiadas + config) — Gap A1 (appointment-manage)
  'appointment_manage',
  // NOOVI: gestão da Análise Comercial (gerar/excluir relatórios) — hardening RF-A2 (fase-31)
  'commercial_analysis_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const PIPELINE_MANAGE_PERMISSIONS = 'pipeline_manage';

export const PIPELINE_VIEW_PERMISSIONS = 'pipeline_view';

// NOOVI: Follow Up management — Gap FU-A (fase-11)
export const FOLLOW_UP_MANAGE_PERMISSIONS = 'follow_up_manage';

// NOOVI: Appointments management — Gap A1 (appointment-manage)
export const APPOINTMENT_MANAGE_PERMISSIONS = 'appointment_manage';

// NOOVI: Commercial Analysis management — hardening RF-A2 (fase-31)
export const COMMERCIAL_ANALYSIS_MANAGE_PERMISSIONS =
  'commercial_analysis_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
